import { usePageQuery } from 'src/hooks/use-page-query';
import type { ArticleQueryVariables, ArticleQuery } from 'src/types';
import query from '../query.graphql';

export function useArticlePageQuery(variables: ArticleQueryVariables) {
  return usePageQuery<ArticleQuery>({
    query,
    routeName: 'article',
    variables,
  });
}
